import { useRecoilTransaction_UNSTABLE } from "recoil"

import type { TransactionOperation } from ".."
import { startPointState } from "../../../inputs"
import { getMousePositionOnScreen } from "../getMousePosition"
import { tryToDropSelection } from "../tryToDropSelection"

export const startDrag: TransactionOperation = (transactors) => {
  const { set } = transactors
  tryToDropSelection(transactors)
  const mouse = getMousePositionOnScreen(transactors)
  set(startPointState, mouse)
}

export const useStartDrag: () => () => void = () =>
  useRecoilTransaction_UNSTABLE((transactors) => () => startDrag(transactors))
